import { render, staticRenderFns } from "./dialog-confirmation.vue?vue&type=template&id=4064a296&"
import script from "./dialog-confirmation.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./dialog-confirmation.vue?vue&type=style&index=0&id=4064a296&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports